import React from 'react';

import BuildRoundedIcon from '@mui/icons-material/BuildRounded';
import {
  List, ListItemIcon, ListItemText, Tooltip,
} from '@mui/material';

import ContentCard, { ContentCardProps } from '../../../components/ContentCard';
import ListItemButtonLink from '../../../components/ListItemButtonLink';
import { LinkOption } from '../types';

interface ToolsCardProps extends Omit<ContentCardProps, 'children'> {
  tools: LinkOption[];
}

const ToolsCard = ({ tools }: ToolsCardProps) => (
  <ContentCard variant="contained" title="Tools">
    <List>
      {tools.map((tool: LinkOption) => (
        <Tooltip key={tool.label} title={tool.description}>
          <div>
            <ListItemButtonLink
              href={tool.href}
              target="_blank"
              disableRipple
            >
              <>
                <ListItemIcon color="darkPrimary">
                  {tool.icon ?? (<BuildRoundedIcon />)}
                </ListItemIcon>
                <ListItemText
                  primary={tool.label}
                  primaryTypographyProps={{ variant: 'body2' }}
                />
              </>
            </ListItemButtonLink>
          </div>
        </Tooltip>
      ))}
    </List>
  </ContentCard>
);

export default ToolsCard;
